// extracted by mini-css-extract-plugin
export default {"root":"ActivityContainer_root__GrYtK"};